import { instantsInterceptor, } from '@/api/index';

function getCountrys() {
    return instantsInterceptor.get('/service/code/countrys');
}

function getLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}


export { getCountrys, getLanguages };